import { render, staticRenderFns } from "./PlacementBookingTableForm.vue?vue&type=template&id=d717bf90&scoped=true"
import script from "./PlacementBookingTableForm.vue?vue&type=script&lang=js"
export * from "./PlacementBookingTableForm.vue?vue&type=script&lang=js"
import style0 from "./PlacementBookingTableForm.vue?vue&type=style&index=0&id=d717bf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d717bf90",
  null
  
)

export default component.exports